import i18n from '../../../i18n'

const isDigit = /^\d+$/

export const assignPeselNumberFormValidation = values => {
  const errors = {}

  if (!values.peselNumber) {
    errors.peselNumber = i18n.t('common.validation.required')
  }
  else if (values.peselNumber && values.peselNumber.length !== 11) {
    errors.peselNumber = i18n.t(
      'assignPeselNumber.assignForm.validation.invalidLength'
    )
  }
  else if (values.peselNumber && !isDigit.test(values.peselNumber)) {
    errors.peselNumber = i18n.t(
      'assignPeselNumber.assignForm.validation.invalidContent'
    )
  }

  return errors
}
